// extracted by mini-css-extract-plugin
export default {"settingsWrapper":"workspace-settings_settingsWrapper__RxC4D"};